import { useBrand } from '@bnnvara/brand';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import useScrollToCookieConsentModule from '../hooks/useScrollToCookieConsentModule';
import useSendAnalyticScrollPositions from '../hooks/useSendAnalyticScrollPositions';
import StyledSection from './styled';

const ComposablePageLayout = ({ children, page }) => {
  const brand = useBrand();
  const { pathname } = useRouter();
  const elementName = brand ? `${brand.slug}` : page || `page-error`;
  useSendAnalyticScrollPositions('window', elementName);
  useScrollToCookieConsentModule();
  /**
   * Checks if pathname includes a specific string value and passes down true or false to StyledSection as a prop.
   * If the value is TRUE the section background color on the page will change from it's default color.
   */
  const pageWithBackgroundColor =
    pathname.includes('catalogus') ||
    pathname.includes('/[brandSlug]/[slug]') ||
    pathname.includes('/artikelen/[slug]') ||
    pathname.includes('/[brandSlug]/artikelen/[slug]') ||
    pathname.includes('/[brandSlug]/videos/[id]');

  return (
    <StyledSection
      pageWithBackgroundColor={pageWithBackgroundColor}
      aria-label="De BNNVARA website"
    >
      {children}
    </StyledSection>
  );
};

ComposablePageLayout.defaultProps = {
  page: null,
};

ComposablePageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string,
};

export default ComposablePageLayout;
